import { faEdit, faLock, faLockOpen, faPlusSquare, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useContext, useEffect, useState } from 'react';
import { Handle, useReactFlow, useStoreApi, Position } from 'reactflow';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import AppContext from '../../../contexts/AppContext';

function TopEvent({ id, data }) {
  const [lockedByUsername, setLockedByUsername] = useState(data.lockedByUsername)
  const [text, setText] = useState(data.text)
  const { user } = useContext(AppContext)

  useEffect(()=>{
    setLockedByUsername(data.lockedByUsername)
  },[data.lockedByUsername])

  useEffect(()=>{
    setText(data.text)
  },[data.text])

  return (
    <div>
      <Handle style={{ width: '10px', height: '6px', top: '-6px' }} type="target" position={Position.Top} id={'handle-top'} />
      <div className="custom-node__header bg-red-200 rounded-t-[15px] flex justify-between">
        <strong>Harmful CE</strong>
        <div className={`${lockedByUsername ? 'text-slate-700 bg-slate-100 rounded-tr-[15px]' : 'text-slate-300'} px-2 flex justify-between items-center`}>
          {lockedByUsername ?
            <div><span className='text-[12px] px-1 rounded'><FontAwesomeIcon icon={faLock} /> <span className='ml-1'>{lockedByUsername == user?.sub ? 'You' : data.lockedByUsername}</span></span> </div>
            : <><div data-tooltip-content={'Edit/Lock'} data-tooltip-id='edit' onClick={async () => {
              const status = await data.acquireLock();
              if (status == 200) {
                setLockedByUsername(user.sub)
              }
            }} className='text-slate-600 ml-2 px-[4px] rounded cursor-pointer'>
              <FontAwesomeIcon icon={faEdit} size='sm' />
            </div>
              <Tooltip place='top' id='edit' /></>}

          {(lockedByUsername === user?.sub) &&
            <>
              <div data-tooltip-content={'Save'} data-tooltip-id='save' onClick={() => data.update(text)} className='text-[12px] text-teal-600 ml-2 px-[2px] rounded cursor-pointer'>
                <FontAwesomeIcon icon={faSave} />
              </div>
              <Tooltip place='top' id='save' />
            </>
          }

        </div>        
      </div>
      
      <div className="custom-node__body flex">
        <div data-tooltip-content={'Add Cause of CE'} data-tooltip-id='at' onClick={(e) =>
          data.addThreat(e)} className='h-4 w-4 flex justify-center items-center fixed left-[-8px] top-[44%] z-50 bg-white rounded cursor-pointer'>
          <FontAwesomeIcon icon={faPlusSquare} size='1x' color='black' />
        </div>
        <Tooltip place='bottom' id='at' />
        <textarea
          value={text}
          disabled={(lockedByUsername !== user?.sub)}
          onChange={(e) => { data.text = e.currentTarget.value; setText(data.text); }}
          placeholder={'Event description'}
          rows={"4"} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
            leading-tight focus:outline-none focus:shadow-outline"
        />
        <div data-tooltip-content={'Add Impact of CE'} data-tooltip-id='ac' onClick={(e) => data.addConsequence(e)} className='h-4 w-4 flex justify-center items-center fixed right-[-8px] top-[44%] z-50 bg-white rounded cursor-pointer'>
          <FontAwesomeIcon icon={faPlusSquare} size='1x' color='black' />
        </div>
        <Tooltip place='bottom' id='ac' />
      </div>
      <Handle type="target" position={Position.Left} id={'handle-left'} />
      <Handle type="target" position={Position.Right} id={'handle-right'} />
    </div>
  );
}

export default memo(TopEvent);
